import TextButton, {Props as TextButtonProps} from "@irati/ui/src/Button/TextButton"
import theme from "@irati/ui/src/global/theme"
import styled from "styled-components"

interface Props extends TextButtonProps {
  active: boolean
}
const ToggleButton = styled<Props>(TextButton)`
  background: ${({active}) => (active ? theme.colors.greys.light : "")};
  padding: ${theme.spacing.half} ${theme.spacing.half};
  border-radius: 4px;
  user-select: none;
`

export default ToggleButton
